import { buildModelManager } from "../builder.js";
const DefaultEmailCaptureSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  capturedAt: true,
  createdAt: true,
  discountCode: true,
  email: true,
  firstName: true,
  ipAddress: true,
  lastName: true,
  metadata: true,
  pageUrl: true,
  shopId: true,
  source: true,
  updatedAt: true,
  userAgent: true,
  visitorId: true
};
const modelApiIdentifier = "email_capture";
const pluralModelApiIdentifier = "email_captures";
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailCaptureSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEmailCapture",
    operationReturnType: "CreateEmailCapture",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      email_capture: { required: false, type: "CreateEmailCaptureInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailCaptureSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEmailCaptures",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateEmailCapturesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailCaptureSelection
  }
];
const EmailCaptureManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEmailCaptureSelection,
  operations
);
export {
  DefaultEmailCaptureSelection,
  EmailCaptureManager
};
//# sourceMappingURL=EmailCapture.js.map
